import React from 'react';
import { connect } from 'react-redux'
import PermisosPorPerfl from './PermisosPorPerfil';

//Importación de actions.
import {
    getScreenData,
    resetStatePerPorPerf
} from '../actions/PermisosPorPerfil';

const mapStateToProps = (state) => {
    return {
        data: state.permisosPorPerfil
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (id, currentScope) => {
            dispatch(getScreenData(id, currentScope));
        },
        resetStatePerPorPerf: () => {
            dispatch(resetStatePerPorPerf());
        }
    }
}

//Connect entre el componente y las props y actions.
const Container = connect(mapStateToProps, mapDispatchToProps)(PermisosPorPerfl);

export default Container;